/// <reference path="../app.ts" />
namespace Advant.Crossroads {
    "use strict";

    interface IHomeSchoolCeeb extends angular.IDirective {
    }

    interface IHomeSchoolCeebScope extends angular.IScope {
        ceebCodeField: string;
    }

    interface IHomeSchoolCeebAttributes extends angular.IAttributes {
        ceebCodeField: string;
        advResponse: any;
        title: string;
        cssClass: string;
        ngModel: string;
    }

    homeSchoolCeeb.$inject = ["$parse", "helper", "Restangular", "config"];
    function homeSchoolCeeb($parse: angular.IParseService, helper: IHelper, Restangular: Restangular.IService, config: Advant.Crossroads.ICrossroadsConfig): IHomeSchoolCeeb {
        var updateField = (newValue: any, scope: any, attrs: any) => {
            if (newValue == "Y" || newValue == "1") {
                $parse(attrs.ceebCodeField).assign(scope, "970000");
            }
            else {
                $parse(attrs.ceebCodeField).assign(scope, null);
            }
        }


        var link = (scope: IHomeSchoolCeebScope, element: angular.IAugmentedJQuery, attrs: IHomeSchoolCeebAttributes, ctrl: angular.INgModelController) => {
            scope.$watch(attrs.advModel, (newValue: any) => {
                updateField(newValue, scope, attrs);
            });
        };

        return {
            restrict: "A",
            require: "?ngModel",
            priority: -1,
            link: link,
            replace: true,
        }

    }

    angular.module("app").directive("homeSchoolCeeb", homeSchoolCeeb);
}